import React from 'react';
import {
    Text, View, ScrollView,
    TextInput, FlatList, DeviceEventEmitter
} from 'react-native';
import { debounce } from "lodash";
import { store } from '../../store/store';

import { extendAddressDataList } from '../../utils/services/ExtendedDataUtils';
import { buildOrderRequestData } from '../../utils/services/oms/buildOMSOrderData';
import { isAddressUpdated } from '../../utils/services/locations/UserLocationUtils';
import { checkIsAddressCompleted } from '../../utils/services/user/UserAddressUtils';
import { GetProductCategories } from '../../utils/services/inventory/FilterProductCategories';
import { MoengageEvents, trackMoengageEvents } from '../../utils/services/webapp-services/MoengageUtils';
import { getCartTotalItemCount, updateCartImagesToRedux } from '../../utils/services/oms/UpsertCartData';
import { updateOrderInstructions, updateUserSelectedLocationToRedux } from '../../utils/services/redux/commonRedux';
import { pickPrescriptionImageByCamera, pickPrescriptionImageByGallery } from '../../utils/services/ImagePickerUtils';
import { getPuralStringWithCount, isChemistStoreLoaded, isObjectNotEmpty, vibrateDevice } from '../../utils/services/CommonUtils';
import { OMSOrderDataSubscription, ScreenPushBackData, UserSavedAddressSubscription } from '../../utils/services/subject-behaviour/CommonRxjsService';
import { getCartImagesFromRedux, getCartItemFroRedux, getOrderInstruction, getOrderSavingsAmount, mergeDealListWithCartData, clearRepeatOrderData, calculateCartAmount, upsertCartItem, clearCartData } from '../../utils/services/oms/OMSCartUtils';

import { CartItemView } from '../../utils/widgets/CartItemView';
import { CommonZeroScreen } from '../zero-screens/CommonZeroScreen';
import { SeeAllIcon } from '../../utils/widgets/CommonWidget/Icons';
import { HorizontalDivider } from '../../utils/widgets/Common-Widget';
import { CommonIconCTA, CommonOrderNowCTA } from "../../utils/widgets/CommonCTA";
import { ProductCategoryCardView } from '../../utils/widgets/Inventory/ProductCategoryCardView';

import { ActionFromParent } from '../../utils/constants/ConstantsMapping';
import { ScreenPushBackCode } from '../../utils/constants/SubjectBehaviousConstant';
import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';
import PlaceOMSOrder from '../../utils/services/oms/OMSPlaceOrder';

import ToastModal from '../../utils/modals/ToastModal';
import DealView from '../../utils/widgets/deals/DealView';
import ConfirmationPopup from '../../utils/modals/ConfirmationPopup';
import PhotoCaptureModel from '../../utils/modals/PhotoCaptureModal';
import OrderImageListView from '../../utils/widgets/chemistOrder/OrderImageList';
import LocationSelectionBottomSheet from '../../utils/modals/LocationBottomSheet';

import ModalContent from '../../utils/constants/ModalContentConstant';

export default class CartViewComponent extends React.Component<any, any> {
    eventListener: any;
    constructor(props) {
        super(props);
        const reduxState: any = store.getState();
        let chemistStoreData = reduxState.pharmacyAllData
        this.state = {
            props: props,

            isTabComponent: props?.isTabComponent ?? true,

            actionFromParent: props?.actionFromParent ?? '',
            setActionFromParent: props.setActionFromParent,

            isUserLoggedIn: reduxState.isUserLogin,
            storeProfileLoaded: isChemistStoreLoaded() ?? false,

            cartTotalAmount: 0,

            chemistStoreData: chemistStoreData,
            productCategories: chemistStoreData['productCategories'] ?? [],
            deals: chemistStoreData['dealsData']?.deals ?? [],
            inventoryCount: chemistStoreData['dealsData']?.inventoryCount ?? 0,

            cartProducts: getCartItemFroRedux(),
            prescriptionData: getCartImagesFromRedux(),

            selectedLocation: {},

            // From parent in this case, tab controller and review order screen.
            setSelectedLocation: props?.setSelectedLocation,

            itemToBeRemoved: {},

            additionalInstruction: getOrderInstruction(),
            textInputRef: React.createRef(),

            addressList: [],
            userUpdatedData: {},

            toastModalData: {},

        };
    }

    componentDidMount() {
        UserSavedAddressSubscription.getSavedAddress().subscribe((addressData) => {
            this.setState({ addressList: addressData['addressList'] ?? [] })
        })

        this.cartDataSubscription()
        this.userSelectedAdressSubscription()
        store.subscribe(() => {
            this.cartDataSubscription()
            this.userSelectedAdressSubscription()
        })

        this.eventListener = DeviceEventEmitter.addListener('actionFromParent',
            (action) => this.performActionFromParentComponent(action));

        ScreenPushBackData.getPushBackData().subscribe((data: any) => {
            if (data['pushBackCode'] == ScreenPushBackCode.savedLocationForCart) {
                let addressList = extendAddressDataList(data['pushBackData']['addressList'])
                let userUpdatedData = data['pushBackData']['userUpdatedData']
                this.setState({ userUpdatedData: userUpdatedData })
                this.onSelectSavedLocation(addressList[0])
                UserSavedAddressSubscription.setSavedAddress({
                    hasFetched: true, addressList: addressList
                })
                ScreenPushBackData.clearPushBackData()
            }
        })
    }

    componentWillUnmount() {
        //remove listener
        this.eventListener.remove();
    }

    cartDataSubscription = debounce(this.updateCartData, AppTheme.upsertCartItemDebounce)
    userSelectedAdressSubscription = debounce(this.updateSelectedLocation, AppTheme.debouceTimeout)

    updateCartData() {
        let cartItems = getCartItemFroRedux()
        let cartImageList = getCartImagesFromRedux()
        let cartTotalAmount = calculateCartAmount(cartItems)
        var dealsList = mergeDealListWithCartData({ deals: this.state.deals }).dealsList
        this.setState({
            cartProducts: cartItems,
            prescriptionData: cartImageList,
            cartTotalAmount: cartTotalAmount,
            deals: dealsList
        });
    }

    updateSelectedLocation() {
        const _reduxState: any = store.getState();
        if (isObjectNotEmpty(_reduxState.selectedLocation) && isAddressUpdated({
            oldLocation: this.state.selectedLocation,
            newLocation: _reduxState.selectedLocation
        })) {
            this.state.setSelectedLocation(_reduxState.selectedLocation)
            this.setState({ selectedLocation: _reduxState.selectedLocation })
        }
    }

    getDealsList() {
        var dealsList = this.state.deals ?? []
        return { deals: dealsList, count: dealsList.length }
    }


    checkIfCartItemsExist() {
        if (this.state.cartProducts &&
            this.state.cartProducts?.length) {
            return true
        } else false
    }

    checkIfCartImagesExist() {
        if (this.state.prescriptionData &&
            this.state.prescriptionData?.length) {
            return true
        } else false
    }

    checkIfCartExist() {
        return this.state.cartProducts?.length ||
            (this.state.prescriptionData &&
                this.state.prescriptionData?.length)
    }

    onSelectSavedLocation(updatedLocation) {
        let eventParams = { pid: updatedLocation['pid'] }
        if (updatedLocation['coordinates']) {
            eventParams['latLng'] = updatedLocation['coordinates']
        } else if (updatedLocation['location']) {
            let coordinates = updatedLocation['location'].split(',')
            updatedLocation['coordinates'] = { latitude: coordinates[0], longitude: coordinates[1] }
            eventParams['latLng'] = { latitude: coordinates[0], longitude: coordinates[1] }
        }
        trackMoengageEvents(MoengageEvents.oms_delivery_address_select, eventParams)
        this.state.setSelectedLocation(updatedLocation)
        this.setState({ selectedLocation: updatedLocation })
        updateUserSelectedLocationToRedux(updatedLocation)
        this.closeLocationBottomSheet()
    }

    prepareOrderData() {
        const reduxState: any = store.getState();
        let orderData = {
            cartItems: this.state.cartProducts,
            cartImagesList: this.state.prescriptionData,
            userDetails: reduxState.userDetails,
            selectedStore: reduxState.pharmacyAllData,
            selectedLocation: this.state.selectedLocation,
            additionalInstruction: this.state.additionalInstruction
        }
        return orderData
    }

    performActionFromParentComponent(actionData) {
        let action = actionData.action
        if (action == ActionFromParent.placeOrder) {
            var orderData = this.prepareOrderData()
            this.placeOrder(orderData)
        } else if (action == ActionFromParent.selectLocationInCart) {
            this.showLocationBottomSheet()
            OMSOrderDataSubscription.setomsOrderData({ orderData: orderData })
        } else if (action == ActionFromParent.addNewAddress) {
            var orderData = this.prepareOrderData()
            OMSOrderDataSubscription.setomsOrderData({ orderData: orderData })
            this.props.navigation.navigate(ScreenRoute.upsert_user_address, {
                selectedLocation: this.state.selectedLocation,
                fromReviewOrder: true
            });
        } else if (action == ActionFromParent.showLocationBottoSheet) {
            this.showLocationBottomSheet()
        }
    }

    async placeOrder(orderData) {
        orderData = buildOrderRequestData(orderData)
        let userUpdatedData = this.state.userUpdatedData
        // Condition to check
        // Medication, images, location
        PlaceOMSOrder(this.props, {
            orderData: orderData, userUpdatedData: userUpdatedData,
            setToastModalData: (toastData) => this.setState({ toastModalData: toastData })
        })
    }

    updateCartItem(isAdd, item, quantity = 1) {
        upsertCartItem(isAdd, item, quantity,
            { removeItemFromCartCallback: this.removeItemFromCart })
    }

    removeItemFromCart = (item) => {
        this.setState({ itemToBeRemoved: item })
        this.showRemoveLastItemModal()
    }

    removeImageFromCart(index) {
        vibrateDevice()
        if (getCartTotalItemCount() === 1) {
            this.setState({ itemToBeRemoved: this.state.prescriptionData[index] })
            this.showRemoveLastItemModal()
        } else {
            let prescriptionData = this.state.prescriptionData;
            prescriptionData.splice(index, 1);
            updateCartImagesToRedux(prescriptionData)
        }
    }

    removeLastItemFromCart() {
        clearCartData()
        clearRepeatOrderData()
        this.setState({ additionalInstruction: '' })
    }

    addNewAddress(props, selectedLocation) {
        props.navigation?.navigate(ScreenRoute.upsert_user_address, {
            selectedLocation: checkIsAddressCompleted(selectedLocation) ? {} : selectedLocation,
            fromReviewOrder: true
        });
    }

    navigateToSearchItem = (chemistStoreData) => {
        if (chemistStoreData?.spslEnabled)
            this.navigateToProductCategory(null)
        else {
            if (this.state.isTabComponent) global.navigateFrom = NavigateFrom.cart_component_for_search_medicine
            this.props.navigation.navigate(ScreenRoute.search_medicine)
        }
    }

    navigateToProductCategory = (category) => {
        ScreenPushBackData.setData({ pushBackCode: ScreenPushBackCode.updateProductCategory, pushBackData: category })
        this.props.navigation.navigate(ScreenRoute.search_deals, { category: category })
    }

    showLocationBottomSheet = () => { console.log('### opening location bottom sheet in cart component'); this.setState({ showLocationBottomSheet: true }) }
    closeLocationBottomSheet = () => { console.log('### closing location bottom sheet in cart component'); this.setState({ showLocationBottomSheet: false }) }

    showRemoveLastItemModal() { this.setState({ showRemoveItemPop: true }) }
    closeRemoveItemModal() { this.setState({ showRemoveItemPop: false }) }

    showPhotoCaptureModal() { this.setState({ photoCaptureModal: true }) }
    closePhotoCaptureModal() { this.setState({ photoCaptureModal: false }) }

    capturePhoto(type) {
        trackMoengageEvents(MoengageEvents.oms_order_started);
        if (type == 'camera')
            pickPrescriptionImageByCamera(this.props, {})
        else pickPrescriptionImageByGallery(this.props, {})
    }

    showCartItemAddedToast = () => { this.setState({ showCartItemToast: true }) }
    closeCartItemAddedToast = () => { this.setState({ showCartItemToast: false }) }

    getToastBottomMargin = () => {
        let margin = 24
        if (this.state.isTabComponent)
            margin = margin + AppTheme.bottomNavBarHeight
        // if (this.checkIsAddressCompleted(this.state.selectedLocation))
        //     margin = margin + 68
        if (getOrderSavingsAmount(this.state?.cartProducts) > 0)
            margin = margin + 28
        if (getCartTotalItemCount() > 0)
            margin = margin + AppTheme.estimatedPriceBarHeight
        return margin
    }

    render() {
        return <ScrollView showsVerticalScrollIndicator={false}
            style={{ paddingBottom: this.props?.getBottomPadding() ?? 0 }}>

            <View style={[{}]}>

                {this.checkIfCartExist() ? <View>

                    {/* {checkIsAddressCompleted(this.state.selectedLocation) ?
                        <Pressable onPress={() => {
                            this.showLocationBottomSheet()
                        }}
                            style={[AppStyles.flexRowSpaceBetween, AppStyles.p16,
                            { backgroundColor: AppTheme.color.blue.selected_address_bg }]}>
                            <AddressInfoView isActive={true}
                                location={this.state.selectedLocation}
                                titleColor={AppTheme.color.primary} />
                            <IconView icon={'edit_circle.svg'} size={32} />
                        </Pressable> : null} */}

                    {this.checkIfCartItemsExist() ? <View
                        style={[AppStyles.flexRowSpaceBetween, AppStyles.bg,
                        { paddingHorizontal: 16, paddingVertical: 12 }]}>
                        <Text style={TextStyle.text16b}>
                            {getPuralStringWithCount(this.state.cartProducts?.length)}</Text>
                        <CommonIconCTA title={'Add More'} icon={'add_blue.svg'}
                            width={94} iconSize={12} paddingVertical={4} borderWidth={2}
                            action={() => {
                                this.navigateToSearchItem(this.state.chemistStoreData)
                            }} />
                    </View> : null}

                    {this.checkIfCartItemsExist() &&
                        <FlatList style={[AppStyles.bg]} data={this.state?.cartProducts}
                            keyExtractor={(item, index) => "Cart component: cart_view_" + item?.mmid ?? item?.dealId ?? item.name + '_index_' + index}
                            renderItem={({ item, index }) =>
                                <CartItemView item={item} key={item?.mmid ?? item?.dealId ?? index}
                                    textStyle={TextStyle.text14b} showTotalPrice={true}
                                    updateCartItem={(isAdd, product) =>
                                        this.updateCartItem(isAdd, product)} />}
                            ItemSeparatorComponent={(item) => <HorizontalDivider width={AppTheme.appWidth} />}
                            renderToHardwareTextureAndroid />}


                    {this.checkIfCartImagesExist() ? <View
                        style={[AppStyles.flexRowSpaceBetween, AppStyles.bg,
                        { paddingHorizontal: 16, paddingVertical: 12, marginTop: 8 }]}>
                        <Text style={TextStyle.text16b}>
                            {getPuralStringWithCount(
                                this.state.prescriptionData?.length, 'Photo', 'Photos')}
                        </Text>
                        <CommonIconCTA
                            title={'Add More'} icon={'add_blue.svg'}
                            width={94} iconSize={12} paddingVertical={4} borderWidth={2}
                            action={() => { this.showPhotoCaptureModal() }} />
                    </View> : null}

                    {this.checkIfCartImagesExist() &&
                        <OrderImageListView marginTop={16}
                            imageList={this.state.prescriptionData}
                            removeImageFromList={(index) => this.removeImageFromCart(index)} />}

                    <ScrollView>
                        <View style={[{ marginTop: 16, paddingVertical: 24, paddingHorizontal: 0 }, AppStyles.bg]}></View>
                        <Text style={[TextStyle.text16b, { marginHorizontal: 16, marginTop: 16 }]}>
                            Instructions for the store</Text>
                        <TextInput style={[TextStyle.text14, AppStyles.borderView, AppStyles.m16,
                        AppStyles.px16, AppStyles.py10, AppStyles.bg, { borderColor: AppTheme.color.primary }]}
                            multiline={true} ref={this.state.textInputRef}
                            placeholder={'Write here...'} numberOfLines={4}
                            onChangeText={(text) => {
                                this.setState({ additionalInstruction: text });
                                updateOrderInstructions(text)
                            }} value={this.state.additionalInstruction} />
                    </ScrollView>

                </View> : <View>
                    <CommonZeroScreen screenName={'emptyCart'} />
                    <CommonOrderNowCTA navigation={this.props.navigation} />
                </View>}

                {GetProductCategories(this.state.productCategories, { withDiscount: true })?.length > 0 ? <View style={[AppStyles.bg, { paddingBottom: 16 }]}>
                    <Text style={[TextStyle.text16b, AppStyles.pl16, AppStyles.mt24]}>
                        Shop from discounted categories</Text>
                    <View style={[AppStyles.pl16]}>
                        <FlatList data={GetProductCategories(this.state.productCategories, { withDiscount: true })}
                            horizontal={true} showsHorizontalScrollIndicator={false}
                            keyExtractor={(item, index) => "Cart component: category_view_" + item.cid + '_' + index}
                            renderItem={({ item, index }) => <ProductCategoryCardView index={index}
                                iconSize={90} category={{ ...item, index: index }}
                                action={(category) => this.navigateToProductCategory(category)} />}
                            snapToAlignment="start" />
                    </View>
                </View> : null}

                {this.getDealsList().count > 0 ? <View style={AppStyles.bg}>
                    <View style={[AppStyles.flexRowSpaceBetween, AppStyles.p16]}>
                        <Text style={[TextStyle.text16b]}>Products in Store</Text>
                        <SeeAllIcon itemCount={this.state.inventoryCount}
                            action={() => { this.navigateToProductCategory(null) }} />
                    </View>
                    <FlatList data={this.getDealsList().deals}
                        snapToAlignment="start"
                        keyExtractor={(item, index) => "Cart component: deal_view_" + item.dealId + '_index_' + index}
                        renderItem={({ item, index }) => DealView({
                            deal: { ...item, index: index }, from: "cart view component",
                            navigation: this.props.navigation,
                            updateCartDealItem: (isAdd, product) =>
                                this.updateCartItem(isAdd, product)
                        })} />
                </View> : null}

            </View >

            {
                this.state.showLocationBottomSheet && <LocationSelectionBottomSheet
                    showLocationModal={this.state.showLocationBottomSheet}
                    fromReviewOrder={true} hideSearchocation={true} isUserLoggedIn={this.state.isUserLoggedIn}
                    selectedLocation={this.state.selectedLocation} closeModal={() => this.closeLocationBottomSheet()}
                    addAddress={() => this.addNewAddress(this.props, this.state.selectedLocation)}
                    onSelectSavedLocation={(locationData) => this.onSelectSavedLocation(locationData)} />
            }

            {
                this.state.showRemoveItemPop && <ConfirmationPopup
                    showPopup={this.state.showRemoveItemPop}
                    modalData={ModalContent.RemoveItemFromCart}
                    closeModal={() => this.closeRemoveItemModal()}
                    primaryAction={() => this.removeLastItemFromCart()} />
            }

            {
                this.state.photoCaptureModal && <PhotoCaptureModel
                    showPhotoCaptureModal={this.state.photoCaptureModal}
                    closeModal={() => this.closePhotoCaptureModal()}
                    capturePhotoAction={(type) => this.capturePhoto(type)} />
            }

            {/* {this.state.showCartItemToast && <AddCartItemToast
                closeToast={() => this.closeCartItemAddedToast()}
                showToast={this.state.showCartItemToast}
                bottomMargin={this.getToastBottomMargin()} />} */}

            <ToastModal showToast={this.state.toastModalData['showToast']}
                text={this.state.toastModalData['text']}
                setToast={(toastData) => { this.setState({ toastModalData: toastData }) }} />

        </ScrollView >
    }

}
